import { supabase } from "@/integrations/supabase/client";
import { isBotUserAgent } from "@/lib/visitCounting";

const isTeamBrowser = (): boolean => {
  try { if (localStorage.getItem("rl-analytics-admin") === "1") return true; } catch { /* noop */ }
  try { return /(?:^|; )rl_team=1/.test(document.cookie); } catch { return false; }
};

export const errorReference = (message: string): string =>
  Math.abs(
    Array.from(message).reduce((hash, char) => (hash << 5) - hash + char.charCodeAt(0), 0),
  )
    .toString(36)
    .toUpperCase();

const sent = new Set<string>();

/** Persists a client-side crash so admins can inspect it from the back office. */
export async function reportClientError(
  error: Error,
  extra?: { componentStack?: string | null | undefined; boundary?: string },
): Promise<void> {
  if (typeof window === "undefined") return;
  const message = String(error?.message || error || "Unknown error").slice(0, 2000);
  const key = `${extra?.boundary ?? "root"}:${message}`;
  if (sent.has(key)) return;
  sent.add(key);

  try {
    let userId: string | null = null;
    try {
      const { data } = await supabase.auth.getSession();
      userId = data.session?.user?.id ?? null;
    } catch {
      userId = null;
    }

    await supabase.from("client_error_logs" as any).insert({
      user_id: userId,
      reference: errorReference(message),
      message,
      stack: (error?.stack ?? "").slice(0, 6000) || null,
      component_stack: (extra?.componentStack ?? "").slice(0, 6000) || null,
      route: `${window.location.pathname}${window.location.search}`.slice(0, 500),
      user_agent: navigator.userAgent.slice(0, 500),
      app_version: extra?.boundary ?? null,
      host: window.location.hostname.slice(0, 200),
      is_bot: isBotUserAgent(navigator.userAgent),
      is_internal: isTeamBrowser(),
    } as any);
  } catch {
    // never let error reporting break the error screen
  }
}
